import BaseComponent from './BaseComponent';
// import Swiper        from 'swiper';
import { throttle }  from 'lodash';


class SliderTabs extends BaseComponent {
  constructor(componentName, autoInit = true){
    super(componentName);

    this.options = {
      wrapperClass: 'slides-list',
      slideClass: 'slide',
      centeredSlides: false,
      watchSlidesVisibility: true,
      slidesPerView: 'auto',  // Default slides per view
      spaceBetween: 20,
      loop: false,
      navigation: {
        prevEl: '.slider_tabs__btn--prev',
        nextEl: '.slider_tabs__btn--next'
      },
      pagination: {
        el: '.EMPTY',
        clickable: true,
      },
      speed: 300,
      watchOverflow: true,
      on: {
        init: function () {
          // console.log('swiper initialized for tabs buttons');
        },
      }
    };

    this.isEnabled;
    this.classElement = `.${componentName}`;
  }


  init(component) {
    // scrollWidth to take in count the overflow slides
    // + 40 to give it more margin and avoid super close elements
    const breakpoint = component.element.scrollWidth + 10;
    this.pageWidth = window.matchMedia(`(min-width: ${breakpoint}px)`);

    if (!this.pageWidth.matches || app.device.device == 'mobile') {
      this.slider = new Swiper(this.classElement, this.options);
      component.element.classList.add('slider-active');
      this.isEnabled = true;
    }
    this.addCustomEvents(component.element);
  }


  update(element) {
    if (!this.pageWidth.matches || app.device.device == 'mobile') {
      this.slider = new Swiper(this.classElement, this.options);
      element.classList.add('slider-active');
      this.isEnabled = true;
    }
  }


  addCustomEvents(element) {
    window.addEventListener('resize', _.throttle((e) => {
      if (this.pageWidth.matches) {
        if (!!this.slider) {
          for(let slide of this.slider) {
            slide.destroy(true, true);
          }
          this.slider = undefined;
          element.classList.remove('slider-active');
          this.isEnabled = false;
        }
        return;
      } else {
        if (!this.isEnabled) {
          this.update(element);
        }
      }
    }, 500));

    element.addEventListener('click', (e) => {
      const seeMore = document.getElementsByClassName('slider--link--see-more')[0];
      const seeMoreMobile = document.getElementsByClassName('slider--link--see-more-mobile')[0];
      if(seeMore) {
        if (e.target.classList.contains('see-more')) {
          seeMore.classList.add('active');
          seeMoreMobile.classList.add('active');
        }
        else {
          seeMore.classList.remove('active');
          seeMoreMobile.classList.remove('active');
        }
      }
    })
  }

}

export default SliderTabs;
